<mydocma-app-container [options]="options"></mydocma-app-container>